<app-view class="view-{{getClassName(v)}}" *ngFor="let v of views" [name]="v"></app-view>
